import { render } from "./Container.vue?vue&type=template&id=0ea1355b&scoped=true&ts=true"
import script from "./Container.vue?vue&type=script&lang=ts"
export * from "./Container.vue?vue&type=script&lang=ts"

import "./Container.vue?vue&type=style&index=0&id=0ea1355b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea1355b"]])

export default __exports__